webpackJsonp([0],[
/* 0 */
/*!************************!*\
  !*** multi ./index.js ***!
  \************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /srv/index.js */1);


/***/ }),
/* 1 */
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./src/main */ 2);

/***/ }),
/* 2 */
/*!*********************!*\
  !*** ./src/main.js ***!
  \*********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mo_js__ = __webpack_require__(/*! mo-js */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mo_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mo_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mojs_player__ = __webpack_require__(/*! mojs-player */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mojs_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mojs_player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mojs_curve_editor__ = __webpack_require__(/*! mojs-curve-editor */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mojs_curve_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mojs_curve_editor__);
var _ref;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var star = __webpack_require__(/*! ./star.js */ 6);
var heart = __webpack_require__(/*! ./heart.js */ 7);

// const scaleCurve = new MojsCurveEditor({ name: 'scale' });

// const square1 = new mojs.Html({
//   el: '#js-el',
//   y: { [-300]: -300, curve: 'M0, 0 C10.101525445522112, -1.5300968740935288 24.578551642263555, 1.7142857142857142 30, 87.42857142857143 C33.06687772061731, 107.14285714285714 50, 107 50, 107 C50, 107 62.917147228930936, 104.99294035155644 70, 87.14285714285714 C74.31276966857592, 6.435631077014981 90.03697870960255, 0.67295401695068 100, 0 ' },
//   scaleX: { 1: 1, curve: scaleCurve.getEasing() },
//   duration: 1000
// })
// new MojsPlayer({ add: square1 });

var totalClicks = 0;

var playBurst = function playBurst(posX, posY, e) {
  burst.tune({ x: posX, y: posY }).generate().replay();

  burst1.tune({ x: posX, y: posY }).generate().replay();

  // largeBurst
  //   .tune({ x: posX, y: posY })
  //   .replay();

  largeCircle.tune({ x: posX, y: posY }).replay();

  smallCircle.tune({ x: posX, y: posY }).replay();

  if (totalClicks % 2 === 0) {
    star(e);
  } else {
    heart(e);
  }

  ++totalClicks;
};
// or gui controls instead of `.play()` call
// new MojsPlayer({ add: burst, isPlaying: true, isRepeat: true });

var COLORS = {
  RED: '#FD5061',
  YELLOW: '#FFCEA5',
  BLACK: '#29363B',
  WHITE: 'white',
  VINOUS: '#A50710'
};

var burst = new __WEBPACK_IMPORTED_MODULE_0_mo_js___default.a.Burst({
  radius: { 25: 75 },
  count: 10,
  isSoftHide: true,
  left: 0,
  top: 0,

  duration: 2000,
  onComplete: function onComplete() {
    // console.log( 'completed' );
  },

  children: {
    // property map - maps over children with mod function
    shape: ['circle', 'polygon'],
    // property map - maps over children with mod function
    fill: ['#333', 'magenta', 'purple'],
    angle: { 0: 180 },
    // rand string - generates random value for every child rand( min, max )
    degreeShift: 'rand(-360, 360)',
    // stagger string( start, step ) for every child
    delay: 'stagger(0, 25)'
  }
});

var burst1 = new __WEBPACK_IMPORTED_MODULE_0_mo_js___default.a.Burst({
  left: 0, top: 0,
  count: 8,
  radius: { 50: 150 },
  children: {
    shape: 'line',
    stroke: ['white', '#FFE217', '#FC46AD', '#D0D202', '#B8E986', '#D0D202'],
    scale: 1,
    scaleX: { 1: 0 },
    // pathScale:    'rand(.5, 1.25)',
    degreeShift: 'rand(-90, 90)',
    radius: 'rand(20, 40)',
    // duration:     200,
    delay: 'rand(0, 150)',
    isForce3d: true
  }
});

var largeBurst = new __WEBPACK_IMPORTED_MODULE_0_mo_js___default.a.Burst((_ref = {
  left: 0, top: 0,
  count: 4,
  radius: 0,
  angle: 45
}, _defineProperty(_ref, 'radius', { 0: 450 }), _defineProperty(_ref, 'children', {
  shape: 'line',
  stroke: '#4ACAD9',
  scale: 1,
  scaleX: { 1: 0 },
  radius: 100,
  duration: 450,
  isForce3d: true,
  easing: 'cubic.inout'
}), _ref));

var CIRCLE_OPTS = {
  left: 0, top: 0,
  scale: { 0: 1 }
};

var largeCircle = new __WEBPACK_IMPORTED_MODULE_0_mo_js___default.a.Shape({
  left: 0, top: 0,
  scale: { 0: 1 },
  fill: 'none',
  stroke: 'white',
  strokeWidth: 4,
  opacity: { .25: 0 },
  radius: 250,
  duration: 600
});

var smallCircle = new __WEBPACK_IMPORTED_MODULE_0_mo_js___default.a.Shape({
  left: 0, top: 0,
  scale: { 0: 1 },
  fill: 'white',
  opacity: { .5: 0 },
  radius: 30
});

document.addEventListener('click', function (e) {
  // console.log('click');
  playBurst(e.clientX, e.clientY, e);
}, true);

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/*!*********************!*\
  !*** ./src/star.js ***!
  \*********************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Star = function (_mojs$CustomShape) {
    _inherits(Star, _mojs$CustomShape);

    function Star() {
        _classCallCheck(this, Star);

        return _possibleConstructorReturn(this, (Star.__proto__ || Object.getPrototypeOf(Star)).apply(this, arguments));
    }

    _createClass(Star, [{
        key: 'getShape',
        value: function getShape() {
            return '<path d="M5.51132201,34.7776271 L33.703781,32.8220808 L44.4592855,6.74813038 C45.4370587,4.30369752 47.7185293,3 50,3 C52.2814707,3 54.5629413,4.30369752 55.5407145,6.74813038 L66.296219,32.8220808 L94.488678,34.7776271 C99.7034681,35.1035515 101.984939,41.7850013 97.910884,45.2072073 L75.9109883,63.1330483 L82.5924381,90.3477341 C83.407249,94.4217888 80.4739296,97.6810326 77.0517236,97.6810326 C76.0739505,97.6810326 74.9332151,97.3551083 73.955442,96.7032595 L49.8370378,81.8737002 L26.044558,96.7032595 C25.0667849,97.3551083 23.9260495,97.6810326 22.9482764,97.6810326 C19.3631082,97.6810326 16.2668266,94.4217888 17.4075619,90.3477341 L23.9260495,63.2960105 L2.08911601,45.2072073 C-1.98493875,41.7850013 0.296531918,35.1035515 5.51132201,34.7776271 Z" />';
        }
    }]);

    return Star;
}(mojs.CustomShape);

mojs.addShape('star', Star);

var RADIUS = 28;
var circle = new mojs.Shape({
    left: 0, top: 0,
    stroke: '#FF9C00',
    strokeWidth: _defineProperty({}, 2 * RADIUS, 0),
    fill: 'none',
    scale: { 0: 1, easing: 'quad.out' },
    radius: RADIUS,
    duration: 450
});

var burst = new mojs.Burst({
    left: 0, top: 0,
    radius: { 6: RADIUS - 3 },
    angle: 45,
    children: {
        shape: 'star',
        radius: RADIUS / 2.2,
        fill: '#FD7932',
        degreeShift: 'stagger(0,-5)',
        duration: 700,
        delay: 200,
        easing: 'quad.out'
        // delay:        100,
    }
});

var star = new mojs.Shape({
    left: 0, top: 0,
    shape: 'star',
    fill: '#FF9C00',
    scale: { 0: 1 },
    easing: 'elastic.out',
    duration: 1600,
    delay: 300,
    radius: RADIUS / 2.35
});

var timeline = new mojs.Timeline({ speed: 1.5 });

timeline.add(burst, circle, star);

// document.addEventListener( 'click', function (e) {
//     const coords = { x: e.pageX, y: e.pageY };
//     burst.tune(coords);
//     circle.tune(coords);
//     star.tune(coords);
//     timeline.replay();
// });

module.exports = function (e) {
    var coords = { x: e.pageX, y: e.pageY };
    burst.tune(coords);
    circle.tune(coords);
    star.tune(coords);
    timeline.replay();
};

/***/ }),
/* 7 */
/*!**********************!*\
  !*** ./src/heart.js ***!
  \**********************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Heart = function (_mojs$CustomShape) {
    _inherits(Heart, _mojs$CustomShape);

    function Heart() {
        _classCallCheck(this, Heart);

        return _possibleConstructorReturn(this, (Heart.__proto__ || Object.getPrototypeOf(Heart)).apply(this, arguments));
    }

    _createClass(Heart, [{
        key: 'getShape',
        value: function getShape() {
            return '<path d="M73.6170213,0 C64.4680851,0 56.5957447,5.53191489 51.7021277,13.8297872 C50.8510638,15.3191489 48.9361702,15.3191489 48.0851064,13.8297872 C43.4042553,5.53191489 35.3191489,0 26.1702128,0 C11.9148936,0 0,14.0425532 0,31.2765957 C0,48.0851064 14.893617,77.8723404 47.6595745,99.3617021 C49.1489362,100.212766 50.8510638,100.212766 52.1276596,99.3617021 C83.8297872,78.5106383 99.787234,48.2978723 99.787234,31.2765957 C100,14.0425532 88.0851064,0 73.6170213,0 L73.6170213,0 Z"></path>';
        }
    }]);

    return Heart;
}(mojs.CustomShape);

mojs.addShape('heart', Heart);

var CIRCLE_RADIUS = 20;
var RADIUS = 32;
var circle = new mojs.Shape({
    left: 0, top: 0,
    stroke: '#FF9C00',
    strokeWidth: _defineProperty({}, 2 * CIRCLE_RADIUS, 0),
    fill: 'none',
    scale: { 0: 1 },
    radius: CIRCLE_RADIUS,
    duration: 400,
    easing: 'cubic.out'
});

var burst = new mojs.Burst({
    left: 0, top: 0,
    radius: { 4: RADIUS },
    angle: 45,
    count: 14,
    timeline: { delay: 300 },
    children: {
        radius: 2.5,
        fill: '#FD7932',
        scale: { 1: 0, easing: 'quad.in' },
        pathScale: [.8, null],
        degreeShift: [13, null],
        duration: [500, 700],
        easing: 'quint.out'
    }
});

var heart = new mojs.Shape({
    left: 0, top: 2,
    shape: 'heart',
    fill: '#E5214A',
    scale: { 0: 1 },
    easing: 'elastic.out',
    duration: 1600,
    delay: 300,
    radius: 11
});

// document.addEventListener( 'click', function (e) {
//     const coords = { x: e.pageX, y: e.pageY };
//     burst
//         .tune(coords)
//         .replay();

//     circle
//         .tune( coords )
//         .replay();

//     heart
//         .tune( coords )
//         .replay();

// });

module.exports = function (e) {
    var coords = { x: e.pageX, y: e.pageY };
    burst.tune(coords).replay();

    circle.tune(coords).replay();

    heart.tune(coords).replay();
};

/***/ })
],[0]);


// WEBPACK FOOTER //
// client.69f4c8ea.js